import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { MaskLines, Reveal } from "./Reveal";
import { SITE } from "@/lib/site";

export const CtaBand = ({ title = ["Need a plumber", "you can count on?"] }) => (
  <section data-testid="cta-band" className="relative bg-cobalt text-white overflow-hidden grain">
    <div className="absolute inset-0 blueprint opacity-60" />
    <div className="container-x relative py-24 sm:py-32 grid gap-10 lg:grid-cols-12 items-end">
      <h2 className="lg:col-span-8 font-wide font-black uppercase text-4xl sm:text-6xl lg:text-7xl leading-[0.92] tracking-tight">
        <MaskLines lines={title} />
      </h2>
      <Reveal className="lg:col-span-4 flex flex-col gap-3" delay={0.2}>
        <Link to="/book" data-testid="cta-book-button" className="group flex items-center justify-between bg-white text-ink font-bold px-7 h-16 rounded-full hover:bg-ink hover:text-white transition-colors">
          Book a time online <ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-1" />
        </Link>
        <a href={SITE.tel} data-testid="cta-call-button" className="flex items-center justify-between border border-white/40 px-7 h-16 rounded-full font-mono hover:bg-white hover:text-ink transition-colors">
          <span className="flex items-center gap-2"><Phone className="h-4 w-4" /> Call</span>{SITE.phone}
        </a>
      </Reveal>
    </div>
  </section>
);
